import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useTable, usePagination } from "react-table";
import { toast } from "react-toastify";
import SummaryApi from "../common";
import { useNavigate } from "react-router-dom";
import { FaCog, FaFlag, FaUsers, FaBook } from "react-icons/fa";
import { GrAnnounce } from "react-icons/gr";
import nodata from "../assest/nodata.png";
import notification from "../assest/notification.gif";
import jaykumar from "../assest/tlimages/jaykumar.png";
import tlDefault from "../assest/tl.jpg";
import FollowupModal from "../components/FollowupModal";
import FollowupsOverlay from "../pages/FollowupsOverlay";
import { FaUser } from "react-icons/fa";
import DashboardPdf from "../assest/Dashboard.pdf"

import {
  FaUserGraduate,
  FaCalendarCheck,
  FaStar,
  FaRegStar,
  FaRegThumbsUp,
  FaRegThumbsDown,
  FaRegFrownOpen,
  FaRocketchat,
  FaPhone,
  FaPhoneAlt,
  FaEye,
  FaHistory,
  FaChevronRight,
  FaChevronLeft,
  FaSearch,
  FaClock,
  FaSpinner,
  FaCheckCircle,
  FaHourglassHalf,
  FaUserPlus,
  FaFilter as FaFilterIcon,
  FaSyncAlt,
  FaChartLine,
} from "react-icons/fa";
import Modal from "react-modal";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import BarChartStatus from "./BarChartStatus";
import FollowupsTable from "../pages/FollowupsOverlay";
import { getEmployeeImageUrl } from "../utils/helpers";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

Modal.setAppElement("#root");

const THEME = {
  primary: "#172C57",
  primaryLight: "rgba(23, 44, 87, 0.08)",
  primaryMedium: "rgba(23, 44, 87, 0.6)",
  primaryHover: "#1E3A6E",
  primaryDark: "#0F1E3C",
  textSecondary: "#64748B",
  emerald: "#10B981",
  purple: "#7C3AED",
  red: "#EF4444",
  amber: "#F59E0B",
  blue: "#2563EB",
};

// --- MARQUEE BAR COMPONENT ---
const MarqueeBar = ({ items, theme, label = "Weekly Flash Report" }) => {
  if (!items || !items.length) return null;

  const duration = Math.max(30, items.length * 12);

  const renderGroup = (suffix) => (
    <div className="flex items-center shrink-0" aria-hidden={suffix !== "a"}>
      {items.map((item) => (
        <div
          key={`${item.key}-${suffix}`}
          className="flex items-center gap-3 shrink-0"
          style={{ marginRight: 28 }}
        >
          <img
            src={item.img}
            alt={item.name}
            className="rounded-full object-cover bg-white shrink-0"
            style={{ width: 44, height: 44, border: "2px solid #FBBF24" }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = notification;
            }}
          />
          <span
            className="font-bold whitespace-nowrap"
            style={{ fontSize: 14, color: theme.primary }}
          >
            {item.name}
          </span>
          {item.text && (
            <span
              className="whitespace-nowrap"
              style={{ fontSize: 14, color: theme.textSecondary || "#64748B" }}
            >
              {item.text}
            </span>
          )}
          <span className="text-gray-400" style={{ marginLeft: 8 }}>
            •
          </span>
        </div>
      ))}
    </div>
  );

  return (
    <>
      <style>{`
        @keyframes flashMarquee {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        .flash-marquee-track {
          display: flex;
          width: max-content;
          will-change: transform;
          animation-name: flashMarquee;
          animation-timing-function: linear;
          animation-iteration-count: infinite;
        }
        .flash-marquee:hover .flash-marquee-track {
          animation-play-state: paused;
        }
        .flash-marquee-lane {
          -webkit-mask-image: linear-gradient(to right, #000 94%, transparent);
          mask-image: linear-gradient(to right, #000 94%, transparent);
        }
        @keyframes liveDot {
          0%, 100% { box-shadow: 0 0 0 0 rgba(34,197,94,0.55); }
          50%      { box-shadow: 0 0 0 5px rgba(34,197,94,0); }
        }
      `}</style>

      <div
        className="flash-marquee w-full overflow-hidden bg-white rounded-xl border border-slate-200 shadow-xs mb-5"
        style={{
          display: "grid",
          gridTemplateColumns: "auto minmax(0, 1fr)",
          alignItems: "center",
          height: 64,
        }}
      >
        <div
          className="flex items-center gap-2 bg-white relative z-10"
          style={{
            height: 42,
            marginLeft: 8,
            padding: "0 14px",
            borderRadius: 8,
            border: "1px solid #EEF0F4",
            boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
          }}
        >
          <span
            className="rounded-full bg-green-500"
            style={{ width: 8, height: 8, animation: "liveDot 1.8s infinite" }}
          />
          <FaChartLine size={20} style={{ color: theme.primary }} />
          <span
            className="font-extrabold uppercase whitespace-nowrap"
            style={{
              fontSize: 13,
              letterSpacing: "0.06em",
              color: theme.primary,
            }}
          >
            {label}
          </span>
        </div>

        <div
          className="flash-marquee-lane overflow-hidden flex items-center"
          style={{ height: "100%" }}
        >
          <div
            className="flash-marquee-track"
            style={{ animationDuration: `${duration}s` }}
          >
            {renderGroup("a")}
            {renderGroup("b")}
            {renderGroup("c")}
            {renderGroup("d")}
          </div>
        </div>
      </div>
    </>
  );
};

const RankBadge = ({ rank }) => {
  if (rank === 1) {
    return (
      <div className="relative flex items-center justify-center w-7 h-7">
        <svg viewBox="0 0 28 24" fill="#F59E0B" className="w-7 h-6 drop-shadow-sm">
          <path d="M2 19h24v2H2zm2-2l-2-12 7 5 5-8 5 8 7-5-2 12H4z" />
        </svg>
        <span className="absolute inset-0 flex items-center justify-center text-[10px] font-black text-[#78350F] pt-1.5">
          1
        </span>
      </div>
    );
  }
  if (rank === 2) {
    return (
      <div className="relative flex items-center justify-center w-7 h-7">
        <svg viewBox="0 0 28 24" fill="#94A3B8" className="w-7 h-6 drop-shadow-sm">
          <path d="M2 19h24v2H2zm2-2l-2-12 7 5 5-8 5 8 7-5-2 12H4z" />
        </svg>
        <span className="absolute inset-0 flex items-center justify-center text-[10px] font-black text-[#1E293B] pt-1.5">
          2
        </span>
      </div>
    );
  }
  if (rank === 3) {
    return (
      <div className="relative flex items-center justify-center w-7 h-7">
        <svg viewBox="0 0 28 24" fill="#D97706" className="w-7 h-6 drop-shadow-sm">
          <path d="M2 19h24v2H2zm2-2l-2-12 7 5 5-8 5 8 7-5-2 12H4z" />
        </svg>
        <span className="absolute inset-0 flex items-center justify-center text-[10px] font-black text-white pt-1.5">
          3
        </span>
      </div>
    );
  }
  return (
    <div className="w-6 h-6 rounded-full bg-[#E0E7FF] text-[#3B82F6] font-bold text-xs flex items-center justify-center shadow-xs">
      {rank}
    </div>
  );
};

const Dashboard = () => {
  const navigate = useNavigate();
  const [overallCounts, setOverallCounts] = useState({
    totalStudents: 0,
    totalStudentsUploaded: 0,
    totalLeads: 0,
    studentsCreatedToday: 0,
    interested: 0,
    notInterested: 0,
    mostInterested: 0,
    callBack: 0,
    interestedAddedToday: 0,
    notInterestedAddedToday: 0,
    mostInterestedAddedToday: 0,
    callBackAddedToday: 0,
    today_emp_login_counts:0,
  });
  const [assignedEmployeesCount, setAssignedEmployeesCount] = useState(0);
  const [studentData, setStudentData] = useState([]);
  const [teamLeadsFunnelData, setTeamLeadsFunnelData] = useState([]);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [memberType, setMemberType] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const [callStatusCounts, setCallStatusCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const [remainders, setRemainders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All Status");

  // Dynamic Top Performers State
  const [topPerformers, setTopPerformers] = useState([]);
  const [topPerformersLoading, setTopPerformersLoading] = useState(false);

  const [funnelFilterType, setFunnelFilterType] = useState("today");
  const [funnelDateRange, setFunnelDateRange] = useState({
    start_date: new Date().toISOString().split("T")[0],
    end_date: new Date().toISOString().split("T")[0],
  });

  const [promoModalOpen, setPromoModalOpen] = useState(false);
  const [notificationData, setNotificationData] = useState(null);

  const [followUpModalIsOpen, setFollowUpModalIsOpen] = useState(false);
  const [followupModalStudent, setFollowupModalStudent] = useState(null);

  const [followupPageIndex, setFollowupPageIndex] = useState(0);
  const [followupPageSize, setFollowupPageSize] = useState(5);
  const [followupSearchTerm, setFollowupSearchTerm] = useState("");
  const [currentTime, setCurrentTime] = useState(new Date());
  const [todayFollowups, setTodayFollowups] = useState([]);
  const [followupLoading, setFollowupLoading] = useState(false);

  // Workflow PDF Modal State
  const [workflowModalOpen, setWorkflowModalOpen] = useState(false);

  // --- FETCH TODAY TOP EMPLOYEE PERFORMANCE (DYNAMIC) ---
  const fetchTopPerformers = useCallback(async () => {
    try {
      setTopPerformersLoading(true);
      const endpoint =
        SummaryApi.getTodayEmployeePerformance?.url ||
        "http://192.168.1.190/multi_university_apis/students/getTodayEmployeePerformance.php";
      const method = SummaryApi.getTodayEmployeePerformance?.method || "GET";

      const response = await fetch(endpoint, {
        method,
        headers: {
          Authorization: "Bearer sandeep_university_916",
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      if (result && result.status && Array.isArray(result.data)) {
        const formatted = result.data.map((item) => ({
          rank: Number(item.rank),
          employeeId: item.employee_id,
          name: item.full_name || "Employee",
          employee_image: item?.employee_image,
          avatar:
            item.avatar ||
            item.profile_image ||
            `https://ui-avatars.com/api/?name=${encodeURIComponent(
              item.full_name || "Employee"
            )}&background=172C57&color=fff`,
          metric1: {
            label: "Enrolls",
            value: Number(item.total_enrollments ?? 0),
          },
          metric2: {
            label: "Interested",
            value: Number(item.interested_count ?? 0),
          },
          metric3: {
            label: "Most Int.",
            value: Number(item.most_interested_count ?? 0),
          },
          isTopPerformer: Number(item.rank) === 1,
        }));
        setTopPerformers(formatted);
      } else {
        setTopPerformers([]);
      }
    } catch (error) {
      console.error("Failed to load today's employee performance:", error);
      setTopPerformers([]);
    } finally {
      setTopPerformersLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTopPerformers();

    const perfInterval = setInterval(() => {
      fetchTopPerformers();
    }, 1 * 60 * 1000);

    return () => clearInterval(perfInterval);
  }, [fetchTopPerformers]);

  const marqueeItems = useMemo(() => {
    const performers = [...teamLeadsFunnelData]
      .sort(
        (a, b) =>
          parseInt(String(b.total).replace(/,/g, ""), 10) -
          parseInt(String(a.total).replace(/,/g, ""), 10)
      )
      .map((tl, index) => ({
        key: `perf-${tl.id ?? index}`,
        img: String(tl.id) === "5" ? jaykumar : tlDefault,
        name: tl.name,
        text: `${tl.total} total • ${tl.clicks} most interested • ${tl.imp} interested • ${tl.leads} call back`,
      }));

    const notes = (notificationData || []).map((n, index) => {
      let img = notification;
      if (n.is_image === "1" && n.notification_image) {
        img = `${SummaryApi.notifictionImg.url}/${n.notification_image}`.replace(
          "images/images/",
          "images/"
        );
      }
      return {
        key: `note-${n.notification_id || index}`,
        img,
        name: n.title,
        text: n.description,
      };
    });

    return [...performers, ...notes];
  }, [teamLeadsFunnelData, notificationData]);

  const fetchTodayFollowups = useCallback(async () => {
    const encodedEmpId = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");
    if (!encodedEmpId) {
      // console.warn("No employee ID found in session");
      return;
    }
    const empId = atob(encodedEmpId);
    setFollowupLoading(true);
    try {
      const response = await fetch(SummaryApi.TodayfollowupDatesByEmpIdStudId.url, {
        method: SummaryApi.TodayfollowupDatesByEmpIdStudId.method,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer sandeep_university_916",
        },
        body: JSON.stringify({
          employee_id: empId,
        }),
      });
      const result = await response.json();
      if (result.status && Array.isArray(result.data)) {
        const now = new Date();
        const todayStr = now.toISOString().split("T")[0];

        const studentsWithFutureFollowups = new Set();
        const allFollowups = result.data;

        allFollowups.forEach((item) => {
          if (!item.next_followup_date_time) return;
          const dt = new Date(item.next_followup_date_time);
          if (isNaN(dt.getTime())) return;
          const followupDateStr = dt.toISOString().split("T")[0];
          const studentId = item.student_id;
          if (followupDateStr > todayStr) {
            studentsWithFutureFollowups.add(studentId);
          }
        });

        const todayFollowupsList = allFollowups.filter((item) => {
          if (!item.next_followup_date_time) return false;
          const dt = new Date(item.next_followup_date_time);
          if (isNaN(dt.getTime())) return false;
          const followupDateStr = dt.toISOString().split("T")[0];
          const studentId = item.student_id;
          return followupDateStr === todayStr && !studentsWithFutureFollowups.has(studentId);
        });

        if (todayFollowupsList.length === 0) {
          setTodayFollowups([]);
          return;
        }

        const studentMap = new Map();
        const nowTime = now.getTime();

        todayFollowupsList.forEach((item) => {
          const studentId = item.student_id;
          const followupTime = new Date(item.next_followup_date_time);
          const followupTimeMs = followupTime.getTime();
          const isOverdue = followupTimeMs < nowTime;

          if (!studentMap.has(studentId)) {
            studentMap.set(studentId, {
              ...item,
              followupTime: followupTime,
              followupTimeMs: followupTimeMs,
              isOverdue: isOverdue,
            });
          } else {
            const existing = studentMap.get(studentId);
            const existingTimeMs = existing.followupTimeMs;
            const existingIsOverdue = existing.isOverdue;

            if (isOverdue && existingIsOverdue) {
              if (followupTimeMs > existingTimeMs) {
                studentMap.set(studentId, {
                  ...item,
                  followupTime: followupTime,
                  followupTimeMs: followupTimeMs,
                  isOverdue: true,
                });
              }
            } else if (!isOverdue && existingIsOverdue) {
              studentMap.set(studentId, {
                ...item,
                followupTime: followupTime,
                followupTimeMs: followupTimeMs,
                isOverdue: false,
              });
            } else if (!isOverdue && !existingIsOverdue) {
              if (followupTimeMs < existingTimeMs) {
                studentMap.set(studentId, {
                  ...item,
                  followupTime: followupTime,
                  followupTimeMs: followupTimeMs,
                  isOverdue: false,
                });
              }
            }
          }
        });

        let uniqueTodayFollowups = Array.from(studentMap.values());

        uniqueTodayFollowups.sort((a, b) => {
          const aIsOverdue = a.isOverdue;
          const bIsOverdue = b.isOverdue;
          if (aIsOverdue && !bIsOverdue) return 1;
          if (!aIsOverdue && bIsOverdue) return -1;
          if (!aIsOverdue && !bIsOverdue) {
            return a.followupTimeMs - b.followupTimeMs;
          } else {
            return b.followupTimeMs - a.followupTimeMs;
          }
        });

        setTodayFollowups(uniqueTodayFollowups);
      } else {
        setTodayFollowups([]);
      }
    } catch (err) {
      console.error("Failed to load today's follow-ups:", err);
      setTodayFollowups([]);
    } finally {
      setFollowupLoading(false);
    }
  }, []);

  useEffect(() => {
    if (todayFollowups.length === 0) return;

    const interval = setInterval(() => {
      const now = new Date();
      setCurrentTime(now);

      const shouldRefresh = todayFollowups.some((item) => {
        if (!item.next_followup_date_time) return false;
        const followupTime = new Date(item.next_followup_date_time);
        if (isNaN(followupTime.getTime())) return false;
        const timePassedMs = now - followupTime;
        return timePassedMs >= 0 && timePassedMs <= 60000;
      });

      if (shouldRefresh) {
        fetchTodayFollowups();
      }
    }, 30000);

    return () => clearInterval(interval);
  }, [todayFollowups, fetchTodayFollowups]);

  const filteredTodayFollowups = useMemo(() => {
    if (!followupSearchTerm.trim()) return todayFollowups;
    const searchLower = followupSearchTerm.toLowerCase().trim();
    return todayFollowups.filter((item) => {
      return (
        (item.student_name || "").toLowerCase().includes(searchLower) ||
        (item.mobile_number1 || "").includes(searchLower) ||
        (item.is_interested || "").toLowerCase().includes(searchLower) ||
        (item.lead_description || "").toLowerCase().includes(searchLower) ||
        (item.next_followup_date_time || "").toLowerCase().includes(searchLower)
      );
    });
  }, [todayFollowups, followupSearchTerm]);

  const paginatedFollowups = useMemo(() => {
    const start = followupPageIndex * followupPageSize;
    return filteredTodayFollowups.slice(start, start + followupPageSize);
  }, [filteredTodayFollowups, followupPageIndex, followupPageSize]);

  const totalFollowupPages = Math.ceil(filteredTodayFollowups.length / followupPageSize);

  const formatDate = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const handleFollowUpClick = useCallback(
    async (item) => {
      const studentIdToFetch = item.student_id;
      const tlStudentFollowupIdToFetch = item.tl_student_followup_id;

      if (!studentIdToFetch) {
        toast.error("Student ID is missing for this entry. Cannot fetch full details.");
        return;
      }

      try {
        const responseDetails = await fetch(SummaryApi.getStudentDataByStudentId.url, {
          method: SummaryApi.getStudentDataByStudentId.method,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer sandeep_university_916",
          },
          body: JSON.stringify({ student_id: studentIdToFetch }),
        });
        const studentDataRes = (await responseDetails.json()).data || null;

        let followUps = [];
        if (tlStudentFollowupIdToFetch) {
          const responseFollow = await fetch(SummaryApi.getStudentFollowDetails.url, {
            method: SummaryApi.getStudentFollowDetails.method,
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer sandeep_university_916",
            },
            body: JSON.stringify({
              tl_student_followup_id: tlStudentFollowupIdToFetch,
            }),
          });
          const followData = await responseFollow.json();
          followUps = followData.data || [];
        }

        navigate("/my-history", {
          state: {
            student: item,
            studentDetails: studentDataRes,
            studentFollowUps: followUps,
          },
        });
      } catch (error) {
        console.error("Error in handleFollowUpClick:", error);
        toast.error("Failed to fetch student details.");
      }
    },
    [navigate]
  );

  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "sno",
        id: "sno",
      },
      {
        Header: "Employee Name",
        accessor: "employee_name",
        id: "employeeName",
      },
      {
        Header: "Student Name",
        accessor: "student_name",
        id: "studentName",
      },
      {
        Header: "Mobile",
        accessor: "mobile_number1",
        id: "mobile",
      },
      {
        Header: "Enrollment Code",
        accessor: "enrollment_code",
        id: "enrollmentCode",
      },
      {
        Header: "Status",
        accessor: "is_interested",
        id: "status",
      },
      {
        Header: "Action",
        id: "actions",
        Cell: ({ row }) => (
          <div className="flex items-center space-x-2">
            <button
              onClick={() => {
                setSelectedStudent(row.original);
                setModalIsOpen(true);
              }}
              className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white px-3.5 py-1.5 rounded-md text-xs font-medium transition-colors shadow-sm flex items-center cursor-pointer"
              title="View Details"
            >
              <FaEye className="mr-1.5" size={12} />
              View Details
            </button>

            {(memberType === "Admin" ||
              memberType === "Manager" ||
              memberType === "Team Lead") && (
                <button
                  onClick={() => handleFollowUpClick(row.original)}
                  style={{ backgroundColor: THEME.primary }}
                  className="hover:opacity-90 text-white px-3.5 py-1.5 rounded-md text-xs font-medium transition-opacity shadow-sm flex items-center cursor-pointer"
                  title="Follow Up"
                >
                  <FaHistory className="mr-1.5" size={12} />
                  Follow up
                </button>
              )}
          </div>
        ),
      },
    ],
    [memberType, handleFollowUpClick]
  );

  const tableData = useMemo(() => {
    let data = studentData;
    if (statusFilter !== "All Status") {
      data = data.filter((student) => {
        const studentStatus = student.is_interested || "";
        return studentStatus === statusFilter;
      });
    }
    return data.map((student, index) => ({
      ...student,
      sno: index + 1,
      employee_name: student.employee_name || "N/A",
    }));
  }, [studentData, statusFilter]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data: tableData,
      initialState: { pageIndex: 0, pageSize: 5 },
    },
    usePagination
  );

  const handleFunnelFilterChange = (e) => {
    const type = e.target.value;
    setFunnelFilterType(type);

    const today = new Date();
    let start = new Date();
    let end = new Date();

    if (type === "yesterday") {
      start.setDate(today.getDate() - 1);
      end.setDate(today.getDate() - 1);
    } else if (type === "last7days") {
      start.setDate(today.getDate() - 7);
    } else if (type === "last15days") {
      start.setDate(today.getDate() - 15);
    } else if (type === "last30days") {
      start.setDate(today.getDate() - 30);
    } else if (type === "all") {
      start = new Date("2000-01-01");
    }

    setFunnelDateRange({
      start_date: formatDate(start),
      end_date: formatDate(end),
    });
  };

  // --- API DATA FETCH WITH DYNAMIC KPI VALUE MAPPING ---
  const fetchDashboardData = useCallback(async () => {
    try {
      const encodedMemberType = sessionStorage.getItem("K3M8X1JQ5VZ4B7PWTL9");
      const memberTypeVal = encodedMemberType ? atob(encodedMemberType) : null;
      setMemberType(memberTypeVal);
      const userRaw = sessionStorage.getItem("user")
      const user = userRaw ? JSON.parse(userRaw) : {}

      let currentEmployeeId = null;
      let response;
      let todayResponse;

      const dashboardApiUrl =
        SummaryApi.dashboardcounts?.url ||
        "http://192.168.1.190/multi_university_apis/students/dashboard.php";

      if (memberTypeVal === "Admin" || memberTypeVal === "Manager") {
        response = await fetch(dashboardApiUrl, {
          method: SummaryApi.dashboardcounts?.method || "GET",
          headers: {
            Authorization: "Bearer sandeep_university_916",
            "Content-Type": "application/json",
          },
        });

        todayResponse = await fetch(SummaryApi.todaystudents.url, {
          method: SummaryApi.todaystudents.method,
          headers: {
            Authorization: "Bearer sandeep_university_916",
            "Content-Type": "application/json",
          },
        });

        try {
          const tlResponse = await fetch(SummaryApi.getAllTL.url, {
            method: SummaryApi.getAllTL.method,
            headers: {
              Authorization: "Bearer sandeep_university_916",
              "Content-Type": "application/json",
            },
          });
          const tlData = await tlResponse.json();

          if (tlData.status && tlData.data) {
            const tlStatsPromises = tlData.data.map(async (tl) => {
              try {
                const payload = {
                  team_lead_emp_id: tl.id || tl.employee_id,
                  start_date: funnelDateRange.start_date,
                  end_date: funnelDateRange.end_date,
                };

                const statsRes = await fetch(SummaryApi.tlEmpcountStatus.url, {
                  method: SummaryApi.tlEmpcountStatus.method,
                  headers: {
                    Authorization: "Bearer sandeep_university_916",
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(payload),
                });

                const statsData = await statsRes.json();

                let actualInterested = 0;
                let actualMostInterested = 0;
                let callBackCount = 0;

                if (statsData.status && statsData.interested_counts) {
                  actualInterested = parseInt(
                    statsData.interested_counts.actual_interested || 0,
                    10
                  );
                  actualMostInterested = parseInt(
                    statsData.interested_counts.actual_most_interested || 0,
                    10
                  );
                  callBackCount = parseInt(
                    statsData.interested_counts.actual_call_back || 0,
                    10
                  );
                }

                const totalActivity =
                  actualInterested + actualMostInterested + callBackCount;

                return {
                  id: tl.id || tl.employee_id,
                  name: tl.full_name,
                  employee_image: tl.employee_image,
                  total: totalActivity.toLocaleString(),
                  imp: actualInterested.toLocaleString(),
                  clicks: actualMostInterested.toLocaleString(),
                  leads: callBackCount.toLocaleString(),
                };
              } catch (err) {
                return {
                  id: tl.id || tl.employee_id,
                  name: tl.full_name,
                  total: "0",
                  imp: "0",
                  clicks: "0",
                  leads: "0",
                };
              }
            });

            const formattedTLData = await Promise.all(tlStatsPromises);
            setTeamLeadsFunnelData(formattedTLData);
          }
        } catch (error) {
          console.error("Error fetching Team Leads:", error);
        }
      } else if (memberTypeVal === "Team Lead") {
        const encodedTeamLeadId = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");
        currentEmployeeId = atob(encodedTeamLeadId);
        setEmployeeId(currentEmployeeId);

        response = await fetch(SummaryApi.getDashboardDataForTeamLead.url, {
          method: SummaryApi.getDashboardDataForTeamLead.method || "PUT",
          headers: {
            Authorization: "Bearer sandeep_university_916",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ team_lead_emp_id: currentEmployeeId }),
        });

        todayResponse = await fetch(SummaryApi.todayenrolledStudentByEmpId.url, {
          method: SummaryApi.todayenrolledStudentByEmpId.method,
          headers: {
            Authorization: "Bearer sandeep_university_916",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ team_lead_emp_id: currentEmployeeId }),
        });

        try {
          const payload = {
            team_lead_emp_id: currentEmployeeId,
            start_date: funnelDateRange.start_date,
            end_date: funnelDateRange.end_date,
          };

          const tlFunnelResponse = await fetch(SummaryApi.tlEmpcountStatus.url, {
            method: SummaryApi.tlEmpcountStatus.method,
            headers: {
              Authorization: "Bearer sandeep_university_916",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          });

          const tlFunnelData = await tlFunnelResponse.json();


          if (tlFunnelData.status && tlFunnelData.interested_counts) {
            const actualInterested = parseInt(
              tlFunnelData.interested_counts.actual_interested || 0,
              10
            );
            const actualMostInterested = parseInt(
              tlFunnelData.interested_counts.actual_most_interested || 0,
              10
            );
            const callBackCount = parseInt(
              tlFunnelData.interested_counts.actual_call_back || 0,
              10
            );

            const totalActivity =
              actualInterested + actualMostInterested + callBackCount;

            setTeamLeadsFunnelData([
              {
                id: currentEmployeeId,
                name: "My Team Performance",
                total: totalActivity.toLocaleString(),
                imp: actualInterested.toLocaleString(),
                clicks: actualMostInterested.toLocaleString(),
                leads: callBackCount.toLocaleString(),
                employee_image: user?.employee_image
              },
            ]);
          }
        } catch (error) {
          console.error("Error fetching TL Funnel Data:", error);
        }
      } else {
        const encodedEmployeeId = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");
        if (!encodedEmployeeId) {
          throw new Error("Employee ID not found in session storage");
        }
        currentEmployeeId = atob(encodedEmployeeId);
        setEmployeeId(currentEmployeeId);

        response = await fetch(SummaryApi.dashboardcountsById.url, {
          method: SummaryApi.dashboardcountsById.method,
          headers: {
            Authorization: "Bearer sandeep_university_916",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ employee_id: currentEmployeeId }),
        });

        todayResponse = await fetch(SummaryApi.todaystudentsById.url, {
          method: SummaryApi.todaystudentsById.method,
          headers: {
            Authorization: "Bearer sandeep_university_916",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ employee_id: currentEmployeeId }),
        });
      }

      if (!response.ok) {
        throw new Error("Failed to fetch data from the endpoint");
      }

      const data = await response.json();
      const todayStudentsData = await todayResponse.json();

      let dashboardData = {};

      if (Array.isArray(data?.data)) {
        setAssignedEmployeesCount(Number(data.total_assigned_employees ?? data.data.length));
        dashboardData = data.data.reduce(
          (acc, item) => {
            const counts = item.counts || {};
            acc.total_students += Number(counts.total_students || 0);
            acc.total_uploaded_students += Number(counts.total_uploaded_students || 0);
            acc.total_interested_count += Number(counts.total_interested_count || 0);
            acc.total_most_interested_count += Number(counts.total_most_interested_count || 0);
            acc.total_not_interested_count += Number(counts.total_not_interested_count || 0);
            acc.today_student_count += Number(counts.today_student_count || 0);
            acc.today_interested_count += Number(counts.today_interested_count || 0);
            acc.today_most_interested_count += Number(counts.today_most_interested_count || 0);
            acc.today_not_interested_count += Number(counts.today_not_interested_count || 0);
            acc.today_call_back_count += Number(counts.today_call_back_count || 0);
            acc.total_not_answered_count += Number(counts.total_not_answered_count || 0);
            acc.total_call_back_count += Number(counts.total_call_back_count || 0);
            acc.total_contacted_count += Number(counts.total_contacted_count || 0);
            return acc;
          },
          {
            total_students: 0,
            total_uploaded_students: 0,
            total_interested_count: 0,
            total_most_interested_count: 0,
            total_not_interested_count: 0,
            today_student_count: 0,
            today_interested_count: 0,
            today_most_interested_count: 0,
            today_not_interested_count: 0,
            today_call_back_count: 0,
            total_not_answered_count: 0,
            total_call_back_count: 0,
            total_contacted_count: 0,
          }
        );
      } else {
        dashboardData = data?.data || {};
      }

      setOverallCounts({
        totalStudents: Number(dashboardData.total_students ?? 0),
        totalStudentsUploaded: Number(dashboardData.total_uploaded_students ?? 0),
        totalLeads: Number(
          dashboardData.total_uploaded_students ??
          0
        ),
        studentsCreatedToday: Number(dashboardData.today_student_count ?? 0),
        interested: Number(dashboardData.total_interested_count ?? 0),
        notInterested: Number(dashboardData.total_not_interested_count ?? 0),
        mostInterested: Number(dashboardData.total_most_interested_count ?? 0),
        callBack: Number(
          dashboardData.total_call_back_count ??
          dashboardData.total_callback_count ??
          dashboardData.total_callback ??
          0
        ),
        interestedAddedToday: Number(dashboardData.today_interested_count ?? 0),
        notInterestedAddedToday: Number(dashboardData.today_not_interested_count ?? 0),
        mostInterestedAddedToday: Number(dashboardData.today_most_interested_count ?? 0),
        callBackAddedToday: Number(
          dashboardData.today_call_back_count ??
          dashboardData.today_callback_count ??
          dashboardData.today_callback ??
          0
        ),
        today_emp_login_counts:Number(dashboardData.today_emp_login_counts ?? 0),
        total_active_employees:Number(dashboardData.total_active_employees ?? 0),
      });

      setCallStatusCounts({
        Contacted: Number(dashboardData.total_contacted_count ?? 0),
        "Not Answered": Number(dashboardData.total_not_answered_count ?? 0),
      });

      let processedStudentData = todayStudentsData?.data || [];

      if (memberTypeVal === "Team Lead" && currentEmployeeId) {
        const today = new Date().toISOString().split("T")[0];
        processedStudentData = processedStudentData.filter(
          (student) => student.is_interested === "Interested"
        );

        const studentsWithFollowUpStatus = await Promise.all(
          processedStudentData.map(async (student) => {
            let followedUpByTLToday = false;
            if (student.tl_student_followup_id) {
              const followUpResponse = await fetch(SummaryApi.getStudentFollowDetails.url, {
                method: SummaryApi.getStudentFollowDetails.method,
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer sandeep_university_916",
                },
                body: JSON.stringify({
                  tl_student_followup_id: student.tl_student_followup_id,
                }),
              });
              const followUpDetails = await followUpResponse.json();

              if (followUpDetails.status && followUpDetails.data) {
                followedUpByTLToday = followUpDetails.data.some(
                  (followUp) =>
                    followUp.employee_id === currentEmployeeId &&
                    followUp.created_date.startsWith(today)
                );
              }
            }
            return { ...student, followedUpByTLToday };
          })
        );
        processedStudentData = studentsWithFollowUpStatus;
      }

      setStudentData(processedStudentData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }, [funnelDateRange]);

  const fetchRemainders = useCallback(async () => {
    const encodedEmployeeId = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");
    if (!encodedEmployeeId) {
      toast.error("Employee ID not found. Please log in again.");
      return;
    }
    const teamLeadEmpId = atob(encodedEmployeeId);
    try {
      const response = await fetch(SummaryApi.TlRemainders.url, {
        method: "POST",
        headers: {
          Authorization: "Bearer sandeep_university_916",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ team_lead_emp_id: teamLeadEmpId }),
      });

      const data = await response.json();
      if (data.status) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const filteredRemainders = data.data.filter((remainder) => {
          if (!remainder.next_followup_date_time) return false;
          const reminderDate = new Date(remainder.next_followup_date_time);
          reminderDate.setHours(0, 0, 0, 0);
          return reminderDate.getTime() === today.getTime();
        });
        setRemainders(filteredRemainders);
      }
    } catch (err) {
      console.error("Failed to fetch remainders:", err);
    }
  }, []);

  useEffect(() => {
    fetchTodayFollowups();
  }, [fetchTodayFollowups]);

  const fetchNotifications = useCallback(async () => {
    try {
      const response = await fetch(SummaryApi.getActiveNotification.url, {
        method: SummaryApi.getActiveNotification.method,
        headers: {
          Authorization: "Bearer sandeep_university_916",
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();

      if (data.status && data.data && data.data.length > 0) {
        const activeNotes = data.data.filter((n) => n.is_active === "1");
        if (activeNotes.length > 0) {
          setNotificationData(activeNotes);
        }
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  }, []);

  useEffect(() => {
    fetchDashboardData();
    fetchNotifications();
  }, [fetchDashboardData, fetchNotifications]);

  useEffect(() => {
    if (memberType === "Team Lead") {
      fetchRemainders();
    }
  }, [memberType, fetchRemainders]);

  // const isMan = memberType === "Manager" || memberType === "Admin";
  const isAccessible =
    memberType === "Team Lead" || memberType === "Manager" || memberType === "Admin" || memberType === "Employee";

  const handleCardClick = (card) => {
    if (!card.isClickable) return;
    if (isMan || memberType === 'Employee' && card.url) {
      navigate(card.url);
      return;
    }

    const params = new URLSearchParams();
    if (card.filter) params.set("filter", card.filter);
    if (card.targetTab) params.set("tab", card.targetTab);

    const queryString = params.toString();
    const url = `/my-team-data${queryString ? `?${queryString}` : ""}`;

    navigate(url, {
      state: {
        activeTab: card.targetTab,
        filter: card.filter,
      },
    });
  };
const isMan = memberType === "Manager" || memberType === "Admin";
  // --- OVERALL SUMMARY CARDS CONFIG ---
  const overallSummaryCards = [
    ...(isMan
      ? [
          {
            title: "Total Active Employees",
            value: overallCounts.total_active_employees ?? 0,
            icon: FaUser,
            iconBg: "bg-[#EEF4FF]",
            iconColor: "text-[#2563EB]",
            isClickable: true,
            url: "/all-active-employees",
          },
        ]
      : []),
    {
      title: "Total Enrolled Students",
      value: overallCounts.totalStudents ?? 0,
      secondaryValue:
        overallCounts.totalLeads > 0
          ? `/ ${overallCounts.totalLeads.toLocaleString()}`
          : null,
      subtitle: overallCounts.totalLeads > 0 ? "Out of total leads" : "All registered students",
      icon: FaUserGraduate,
      iconBg: "bg-[#EEF4FF]",
      iconColor: "text-[#2563EB]",
      isClickable: isAccessible,
      url: isMan ? "/enrolled-students" : "/enrolled-students",
    },
    {
      title: "Total Most Interested",
      value: overallCounts.mostInterested ?? 0,
      subtitle: "All time",
      icon: FaRegStar,
      iconBg: "bg-[#F5F3FF]",
      iconColor: "text-[#7C3AED]",
      isClickable: isAccessible,
      targetTab: "most_interested",
      url: isMan ? "/most-interested-students" : "/enrolled-students?filter=most_interested",
    },
    {
      title: "Total Interested",
      value: overallCounts.interested ?? 0,
      subtitle: "All time",
      icon: FaRegThumbsUp,
      iconBg: "bg-[#ECFDF5]",
      iconColor: "text-[#10B981]",
      isClickable: isAccessible,
      targetTab: "interested",
      url: isMan ? "/interested-students" : "/enrolled-students?filter=interested",
    },
    {
      title: "Total Not Interested",
      value: overallCounts.notInterested ?? 0,
      subtitle: "All time",
      icon: FaRegThumbsDown,
      iconBg: "bg-[#FFF1F2]",
      iconColor: "text-[#EF4444]",
      isClickable: isAccessible,
      targetTab: "not_interested",
      url: isMan ? "/not-interested-students" : "/enrolled-students?filter=not_interested",
    },
    {
      title: "Total Callback",
      value: overallCounts.callBack ?? 0,
      subtitle: "Pending follow-ups",
      icon: FaPhoneAlt,
      iconBg: "bg-[#FFFBEB]",
      iconColor: "text-[#F59E0B]",
      isClickable: isAccessible,
      targetTab: "callback",
      url: isMan ? "/callback-students" : "/callback-students",
    },
  ];

  // --- TODAY SUMMARY CARDS CONFIG ---
  const todaySummaryCards = [
    ...(isMan
      ? [
          {
            title: "Today Employee Login",
            value: overallCounts.today_emp_login_counts ?? 0,
            trend: "Added today",
            trendColor: "text-[#7C3AED]",
            icon: FaUser,
            iconBg: "bg-[#F5F3FF]",
            iconColor: "text-[#7C3AED]",
            isClickable: true,
            filter: "today",
            url: "/all-active-employees?filter=today",
          },
        ]
      : []),
    {
      title: "Today Most Interested",
      value: overallCounts.mostInterestedAddedToday ?? 0,
      trend: "Added today",
      trendColor: "text-[#7C3AED]",
      icon: FaRegStar,
      iconBg: "bg-[#F5F3FF]",
      iconColor: "text-[#7C3AED]",
      isClickable: isAccessible,
      targetTab: "most_interested",
      filter: "today",
      url: isMan ? "/most-interested-students?filter=today" : "/enrolled-students?filter=most_interested_today",
    },
    {
      title: "Today Interested",
      value: overallCounts.interestedAddedToday ?? 0,
      trend: "Added today",
      trendColor: "text-[#10B981]",
      icon: FaRegThumbsUp,
      iconBg: "bg-[#ECFDF5]",
      iconColor: "text-[#10B981]",
      isClickable: isAccessible,
      targetTab: "interested",
      filter: "today",
      url: isMan ? "/interested-students?filter=today" : "/enrolled-students?filter=interested_today",
    },
    {
      title: "Today Not Interested",
      value: overallCounts.notInterestedAddedToday ?? 0,
      trend: "Added today",
      trendColor: "text-[#EF4444]",
      icon: FaRegThumbsDown,
      iconBg: "bg-[#FFF1F2]",
      iconColor: "text-[#EF4444]",
      isClickable: isAccessible,
      targetTab: "not_interested",
      filter: "today",
      url: isMan ? "/not-interested-students?filter=today" : "/enrolled-students?filter=not_interested",
    },
    {
      title: "Today Callback",
      value: overallCounts.callBackAddedToday ?? 0,
      trend: "Added today",
      trendColor: "text-[#F59E0B]",
      icon: FaPhoneAlt,
      iconBg: "bg-[#FFFBEB]",
      iconColor: "text-[#F59E0B]",
      isClickable: isAccessible,
      targetTab: "callback",
      filter: "today",
      url: isMan ? "/callback-students?filter=today" : "/callback-students?filter=today",
    },
  ];

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F8FAFC] p-4 flex items-center justify-center">
        <div className="text-center">
          <FaSpinner
            className="animate-spin text-4xl mx-auto mb-3"
            style={{ color: THEME.primary }}
          />
          <p className="text-slate-600 text-sm font-medium">Loading dashboard data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen text-slate-800 space-y-6">
      {/* Scrolling Flash / Weekly Report Banner */}
      <MarqueeBar items={marqueeItems} theme={THEME} />

      {/* Top Header Card */}
      <div className="bg-white rounded-xl border border-slate-200 px-5 py-4 shadow-xs flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
        <div className="flex items-center gap-3.5">
          <div
            className="w-11 h-11 rounded-full flex items-center justify-center text-white shadow-xs shrink-0"
            style={{ backgroundColor: THEME.primary }}
          >
            <FaChartLine size={20} />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-lg font-bold tracking-tight" style={{ color: THEME.primary }}>
                Performance Dashboard
              </h1>
              {memberType === "Team Lead" && assignedEmployeesCount > 0 && (
                <span className="bg-blue-50 text-blue-700 border border-blue-200 text-[11px] font-semibold px-2 py-0.5 rounded-full">
                  Team Size: {assignedEmployeesCount}
                </span>
              )}
            </div>
            <p className="text-xs text-slate-500">
              Overview of student enrollments, follow-ups, and team analytics.
            </p>
          </div>
        </div>

        {/* View Workflow Button at the end of Performance Dashboard header */}
        {memberType === 'Employee' && <button
          onClick={() => setWorkflowModalOpen(true)}
          style={{ backgroundColor: THEME.primary }}
          className="hover:opacity-90 text-white px-4 py-2 rounded-lg text-xs font-semibold transition-all shadow-sm flex items-center gap-2 cursor-pointer shrink-0"
          title="View Workflow Document"
        >
          <FaBook size={13} />
          <span>View Workflow</span>
        </button>}
      </div>

      {/* KPI Cards Section */}
      <div className="space-y-6">
        {/* Row 1: Overall summary */}
        <div>
          <h2 className="text-sm font-semibold text-slate-500 mb-3 ml-0.5">
            Overall summary
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3.5">
            {overallSummaryCards.map((card, index) => (
              <div
                key={index}
                onClick={() => handleCardClick(card)}
                className={`bg-white rounded-2xl border border-slate-200/90 p-4 flex items-center gap-3.5 transition-all duration-200 ${card.isClickable
                  ? "cursor-pointer hover:shadow-md hover:border-slate-300 hover:-translate-y-0.5"
                  : "shadow-2xs"
                  }`}
              >
                <div
                  className={`w-12 h-12 rounded-full ${card.iconBg} ${card.iconColor} flex items-center justify-center shrink-0`}
                >
                  <card.icon size={20} />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-xs font-medium text-slate-500 truncate mb-0.5">
                    {card.title}
                  </p>
                  <div className="flex items-baseline gap-1">
                    <span className="text-2xl font-extrabold text-slate-900 leading-none">
                      {(card.value ?? 0).toLocaleString()}
                    </span>
                    {card.secondaryValue && (
                      <span className="text-xs font-normal text-slate-400">
                        {card.secondaryValue}
                      </span>
                    )}
                  </div>
                  <p className="text-[11px] font-normal text-slate-400 mt-1 truncate">
                    {card.subtitle}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Row 2: Today */}
        <div>
          <h2 className="text-sm font-semibold text-slate-500 mb-3 ml-0.5">
            Today
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3.5">
            {todaySummaryCards.map((card, index) => (
              <div
                key={index}
                onClick={() => handleCardClick(card)}
                className={`bg-white rounded-2xl border border-slate-200/90 p-4 flex items-center gap-3.5 transition-all duration-200 ${card.isClickable
                  ? "cursor-pointer hover:shadow-md hover:border-slate-300 hover:-translate-y-0.5"
                  : "shadow-2xs"
                  }`}
              >
                <div
                  className={`w-12 h-12 rounded-full ${card.iconBg} ${card.iconColor} flex items-center justify-center shrink-0`}
                >
                  <card.icon size={20} />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-xs font-medium text-slate-500 truncate mb-0.5">
                    {card.title}
                  </p>
                  <div className="flex items-baseline">
                    <span className="text-2xl font-extrabold text-slate-900 leading-none">
                      {(card.value ?? 0).toLocaleString()}
                    </span>
                  </div>
                  <p className={`text-[11px] font-semibold ${card.trendColor} mt-1 truncate`}>
                    {card.trend}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Top Performance Today Section */}
      <div className="bg-gradient-to-b from-white to-[#F8FAFC] rounded-2xl border border-slate-200/90 p-4 sm:p-5 shadow-xs">
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center gap-2">
            <h2 className="text-base sm:text-lg font-bold text-slate-900 tracking-tight">
              Top Performance today
            </h2>
          </div>
          {topPerformersLoading && (
            <FaSpinner className="animate-spin text-slate-400 text-xs" />
          )}
        </div>

        {topPerformers.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3.5">
            {topPerformers.map((item) => (
              <div
                key={item.rank}
                className={`group relative rounded-2xl p-4 flex flex-col justify-between transition-all duration-300 ease-out cursor-default ${item.isTopPerformer
                  ? "bg-[#FFFDF2] border border-[#FDE68A] hover:border-amber-400 hover:shadow-xl hover:shadow-amber-500/10 hover:-translate-y-1.5"
                  : "bg-white border border-slate-200/90 hover:border-blue-300 hover:shadow-xl hover:shadow-blue-500/10 hover:-translate-y-1.5"
                  }`}
              >
                {item.isTopPerformer && (
                  <div className="absolute top-2 right-2 pointer-events-none select-none group-hover:scale-110 transition-transform duration-300">
                    <svg
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                      className="overflow-visible"
                    >
                      <rect
                        x="6"
                        y="16"
                        width="3"
                        height="7.5"
                        rx="1"
                        fill="#F59E0B"
                        transform="rotate(28 6 16)"
                      />
                      <rect
                        x="24"
                        y="6"
                        width="2.5"
                        height="7"
                        rx="1"
                        fill="#10B981"
                        transform="rotate(-25 24 6)"
                      />
                      <rect
                        x="38"
                        y="14"
                        width="3"
                        height="7.5"
                        rx="1"
                        fill="#EF4444"
                        transform="rotate(38 38 14)"
                      />
                      <path
                        d="M34 26L35.2 29L38 30.2L35.2 31.4L34 34.5L32.8 31.4L30 30.2L32.8 29Z"
                        fill="#FBBF24"
                      />
                      <circle cx="16" cy="8" r="1.5" fill="#3B82F6" />
                      <circle cx="36" cy="7" r="1.5" fill="#F59E0B" />
                      <circle cx="12" cy="30" r="1.8" fill="#10B981" />
                      <circle cx="28" cy="36" r="1.5" fill="#EF4444" />
                      <circle cx="43" cy="23" r="1.2" fill="#8B5CF6" />
                    </svg>
                  </div>
                )}

                <div>
                  <div className="flex items-start justify-between">
                    <div className="group-hover:scale-110 transition-transform duration-300">
                      <RankBadge rank={item.rank} />
                    </div>
                    <div className="flex-1 flex justify-center -ml-5">
                      <div className="relative">
                        <img
                          src={getEmployeeImageUrl(item?.employee_image)}
                          alt={item.name}
                          className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm group-hover:scale-105 group-hover:ring-2 group-hover:ring-blue-400/50 transition-all duration-300"
                          onError={(e) => {
                            e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                              item.name
                            )}&background=172C57&color=fff`;
                          }}
                        />
                        <span className="absolute bottom-0 right-0 w-3 h-3 rounded-full bg-emerald-500 border-2 border-white"></span>
                      </div>
                    </div>
                    <div className="w-5" />
                  </div>

                  <h3 className="text-center font-bold text-xs sm:text-sm text-slate-900 mt-3 mb-3 group-hover:text-blue-600 transition-colors truncate">
                    {item.name}
                  </h3>

                  <div className="grid grid-cols-3 divide-x divide-slate-100 text-center py-1.5 bg-slate-50/60 rounded-xl border border-slate-100 group-hover:bg-slate-50 transition-colors">
                    <div className="px-1">
                      <p className="text-sm font-bold text-slate-900 leading-tight group-hover:scale-105 transition-transform">
                        {item.metric1.value}
                      </p>
                      <p className="text-[10px] text-slate-500 font-medium mt-0.5 truncate">
                        {item.metric1.label}
                      </p>
                    </div>

                    <div className="px-1">
                      <p
                        className={`text-sm font-bold leading-tight group-hover:scale-105 transition-transform ${item.isTopPerformer ? "text-[#B45309]" : "text-emerald-600"
                          }`}
                      >
                        {item.metric2.value}
                      </p>
                      <p className="text-[10px] text-slate-500 font-medium mt-0.5 truncate">
                        {item.metric2.label}
                      </p>
                    </div>

                    <div className="px-1">
                      <p className="text-sm font-bold text-[#7C3AED] leading-tight group-hover:scale-105 transition-transform">
                        {item.metric3.value}
                      </p>
                      <p className="text-[10px] text-slate-500 font-medium mt-0.5 truncate">
                        {item.metric3.label}
                      </p>
                    </div>
                  </div>
                </div>

                {item.isTopPerformer && (
                  <div className="mt-3 text-center">
                    <span className="inline-block bg-gradient-to-r from-[#FDE68A] to-[#FCD34D] text-[#78350F] text-[10px] font-extrabold px-3.5 py-0.5 rounded-full shadow-2xs group-hover:shadow-md transition-shadow">
                      ⭐ Top Performer
                    </span>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8 text-xs text-slate-500 bg-white rounded-xl border border-dashed border-slate-200">
            {topPerformersLoading
              ? "Fetching today's top performers..."
              : "No performance records available for today yet."}
          </div>
        )}
      </div>

      {/* Funnel Section */}
      {(memberType === "Admin" ||
        memberType === "Manager" ||
        memberType === "Team Lead") && (
          <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-xs">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-5 pb-3 border-b border-slate-100">
              <div>
                <h3 className="text-base font-bold" style={{ color: THEME.primary }}>
                  {memberType === "Team Lead"
                    ? "My Team Performance"
                    : "Performance Funnel by Team Lead"}
                </h3>
                <p className="text-xs text-slate-500 mt-0.5">
                  {funnelFilterType === "all"
                    ? "Tracking All-Time Performance"
                    : `Period: ${funnelDateRange.start_date} to ${funnelDateRange.end_date}`}
                </p>
              </div>

              <div className="flex items-center gap-4 flex-wrap">
                <div className="hidden md:flex items-center gap-4 text-xs font-medium text-slate-600">
                  <span className="flex items-center gap-1.5">
                    <span className="w-2.5 h-2.5 rounded-full bg-[#7C3AED]"></span> Most Interested
                  </span>
                  <span className="flex items-center gap-1.5">
                    <span className="w-2.5 h-2.5 rounded-full bg-[#10B981]"></span> Interested
                  </span>
                  <span className="flex items-center gap-1.5">
                    <span className="w-2.5 h-2.5 rounded-full bg-[#F59E0B]"></span> Call Back
                  </span>
                </div>

                <select
                  value={funnelFilterType}
                  onChange={handleFunnelFilterChange}
                  className="bg-white border border-slate-200 rounded-lg px-3 py-1.5 text-xs font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-[#172C57]"
                >
                  <option value="today">📅 Today</option>
                  <option value="yesterday">📅 Yesterday</option>
                  <option value="last7days">📅 Last 7 Days</option>
                  <option value="last15days">📅 Last 15 Days</option>
                  <option value="last30days">📅 Last 30 Days</option>
                  <option value="all">📅 All Time</option>
                </select>
              </div>
            </div>

            <div
              className={`grid gap-4 ${memberType === "Team Lead"
                ? "grid-cols-1 max-w-md mx-auto"
                : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"
                }`}
            >
              {teamLeadsFunnelData.map((team, i) => (
                <div
                  key={i}
                  className="bg-[#F8FAFC] rounded-xl border border-slate-200/80 p-4 hover:shadow-md transition-all duration-200 flex flex-col justify-between"
                >
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2.5">
                      <img
                        src={getEmployeeImageUrl(team.employee_image)}
                        alt={team.name}
                        className="w-10 h-10 rounded-full object-cover border border-slate-300"
                      />
                      <div>
                        <h4 className="text-sm font-bold text-slate-800 leading-tight">
                          {team.name}
                        </h4>
                        <p className="text-[11px] text-slate-500">Lead Funnel</p>
                      </div>
                    </div>
                    <span
                      style={{ backgroundColor: THEME.primary }}
                      className="text-white text-xs font-bold px-2.5 py-1 rounded-full"
                    >
                      {team.total}
                    </span>
                  </div>

                  <div className="flex justify-center items-center my-1">
                    <svg width="210" height="195" viewBox="0 0 220 210" className="max-w-full h-auto">
                      <path d="M25 20 L145 20 L128 68 L42 68 Z" fill="#7C3AED" rx="4" />
                      <text x="85" y="50" textAnchor="middle" fontSize="15" fontWeight="bold" fill="white">
                        {team.clicks}
                      </text>
                      <line x1="148" y1="44" x2="136" y2="44" stroke="#7C3AED" strokeWidth="1.5" strokeDasharray="3 2" />
                      <circle cx="152" cy="44" r="3.5" fill="#7C3AED" />
                      <text x="160" y="42" fontSize="10" fill="#7C3AED" fontWeight="700">Most Int.</text>
                      <text x="160" y="53" fontSize="9" fill="#64748b" fontWeight="600">{team.clicks}</text>

                      <path d="M46 78 L124 78 L110 126 L60 126 Z" fill="#10B981" />
                      <text x="85" y="108" textAnchor="middle" fontSize="15" fontWeight="bold" fill="white">
                        {team.imp}
                      </text>
                      <line x1="148" y1="102" x2="118" y2="102" stroke="#10B981" strokeWidth="1.5" strokeDasharray="3 2" />
                      <circle cx="152" cy="102" r="3.5" fill="#10B981" />
                      <text x="160" y="100" fontSize="10" fill="#10B981" fontWeight="700">Interested</text>
                      <text x="160" y="111" fontSize="9" fill="#64748b" fontWeight="600">{team.imp}</text>

                      <path d="M63 136 L107 136 L100 184 L70 184 Z" fill="#F59E0B" />
                      <text x="85" y="165" textAnchor="middle" fontSize="15" fontWeight="bold" fill="white">
                        {team.leads}
                      </text>
                      <line x1="148" y1="160" x2="104" y2="160" stroke="#F59E0B" strokeWidth="1.5" strokeDasharray="3 2" />
                      <circle cx="152" cy="160" r="3.5" fill="#F59E0B" />
                      <text x="160" y="158" fontSize="10" fill="#D97706" fontWeight="700">Call Back</text>
                      <text x="160" y="169" fontSize="9" fill="#64748b" fontWeight="600">{team.leads}</text>
                    </svg>
                  </div>

                  <div className="grid grid-cols-3 gap-1 pt-2.5 border-t border-slate-200/80 text-center bg-white rounded-lg p-2">
                    <div>
                      <div className="text-[10px] font-medium text-slate-500">Most Int.</div>
                      <div className="text-xs font-bold text-[#7C3AED]">{team.clicks}</div>
                    </div>
                    <div className="border-x border-slate-100">
                      <div className="text-[10px] font-medium text-slate-500">Interested</div>
                      <div className="text-xs font-bold text-[#10B981]">{team.imp}</div>
                    </div>
                    <div>
                      <div className="text-[10px] font-medium text-slate-500">Call Back</div>
                      <div className="text-xs font-bold text-[#F59E0B]">{team.leads}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

      <FollowupsTable />

      {/* Modal for Viewing Workflow PDF (View Only) */}
      <Modal
        isOpen={workflowModalOpen}
        onRequestClose={() => setWorkflowModalOpen(false)}
        contentLabel="Workflow Document"
        className="mx-auto  mt-8 flex flex-col my-6 h-[88vh] w-full max-w-7xl bg-white rounded-2xl shadow-2xl overflow-hidden outline-none"
        overlayClassName="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4 z-50"
      >
        <div
          style={{ backgroundColor: THEME.primary }}
          className="px-6 py-4 flex justify-between items-center text-white"
        >
          <div className="flex items-center gap-3">
            <div className="p-2.5 bg-white/15 rounded-lg">
              <FaBook className="text-white text-base" />
            </div>
            <div>
              <h2 className="text-base font-bold">Standard Workflow</h2>
              <p className="text-slate-200 text-xs">View process guidelines and documentation</p>
            </div>
          </div>
          <button
            onClick={() => setWorkflowModalOpen(false)}
            className="text-white/80 hover:text-white bg-white/10 hover:bg-white/20 w-8 h-8 rounded-full flex items-center justify-center transition-colors text-xl font-bold cursor-pointer"
          >
            &times;
          </button>
        </div>

        <div className="flex-1 w-full h-full bg-[#F8FAFC] p-3 sm:p-4 overflow-hidden flex flex-col">
          <iframe
            src={`${DashboardPdf}#toolbar=0&navpanes=0&scrollbar=1`}
            title="Workflow Document"
            className="w-full flex-1 rounded-xl border border-slate-200 bg-white"
          />
        </div>
      </Modal>

      {/* Modal for Student Details */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        contentLabel="Student Details"
        className="mx-auto flex flex-col my-8 max-h-[90vh] w-full max-w-4xl bg-white rounded-2xl shadow-2xl overflow-hidden outline-none"
        overlayClassName="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center p-4 z-50"
      >
        <div
          style={{ backgroundColor: THEME.primary }}
          className="px-6 py-4 flex justify-between items-center text-white"
        >
          <div className="flex items-center gap-3">
            <div className="p-2.5 bg-white/15 rounded-lg">
              <FaUserGraduate className="text-white text-lg" />
            </div>
            <div>
              <h2 className="text-lg font-bold">Student Details</h2>
              <p className="text-slate-200 text-xs">Complete enrollment profile</p>
            </div>
          </div>
          <button
            onClick={() => setModalIsOpen(false)}
            className="text-white/80 hover:text-white bg-white/10 hover:bg-white/20 w-8 h-8 rounded-full flex items-center justify-center transition-colors text-xl cursor-pointer"
          >
            &times;
          </button>
        </div>

        <div className="p-6 overflow-y-auto bg-[#F8FAFC]">
          {selectedStudent && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div className="bg-white rounded-xl p-5 border border-slate-200 shadow-xs">
                <h3
                  className="text-sm font-bold mb-3 pb-2 border-b border-slate-100"
                  style={{ color: THEME.primary }}
                >
                  Personal Information
                </h3>
                <div className="divide-y divide-slate-100">
                  <DetailRow
                    label="Enrollment Code"
                    value={selectedStudent.enrollment_code}
                    highlight
                  />
                  <DetailRow label="Student Name" value={selectedStudent.student_name} />
                  <DetailRow label="Gender" value={selectedStudent.gender} />
                  <DetailRow label="Father's Name" value={selectedStudent.father_name} />
                  <DetailRow label="Mobile Number" value={selectedStudent.mobile_number1} />
                  <DetailRow
                    label="Alternate Mobile"
                    value={selectedStudent.mobile_number2 || "N/A"}
                  />
                  <DetailRow label="Email" value={selectedStudent.email} />
                  <DetailRow label="Aadhaar Redacted" value="[Aadhaar Redacted]" />
                </div>
              </div>

              <div className="space-y-5">
                <div className="bg-white rounded-xl p-5 border border-slate-200 shadow-xs">
                  <h3
                    className="text-sm font-bold mb-3 pb-2 border-b border-slate-100"
                    style={{ color: THEME.primary }}
                  >
                    Academic Information
                  </h3>
                  <div className="divide-y divide-slate-100">
                    <DetailRow label="Course" value={selectedStudent.course} />
                    <DetailRow label="College" value={selectedStudent.clg_name} />
                    <DetailRow
                      label="Intermediate %/CGPA"
                      value={selectedStudent.inter_percentage}
                    />
                    <DetailRow label="Program Type" value={selectedStudent.program_type} />
                    <DetailRow label="UG/PG Course" value={selectedStudent.ug_pg_course} />
                  </div>
                </div>

                <div className="bg-white rounded-xl p-5 border border-slate-200 shadow-xs flex items-center justify-between">
                  <div>
                    <p className="text-xs text-slate-500 font-medium">Interest Status</p>
                    <p className="text-sm font-bold text-slate-800 mt-0.5">
                      Current Lead Stage
                    </p>
                  </div>
                  <span
                    className={`px-4 py-1.5 rounded-full text-xs font-bold ${selectedStudent.is_interested === "Most Interested"
                      ? "bg-[#F5F3FF] text-[#7C3AED] border border-[#EDE9FE]"
                      : selectedStudent.is_interested === "Interested"
                        ? "bg-[#ECFDF5] text-[#10B981] border border-[#D1FAE5]"
                        : "bg-[#FEF2F2] text-[#EF4444] border border-[#FEE2E2]"
                      }`}
                  >
                    {selectedStudent.is_interested || "Pending"}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal>

      {/* Notification Icon Trigger */}
      <div className="fixed right-3 top-[42%] z-40">
        <img
          src={notification}
          alt="Notifications"
          className="w-12 h-12 cursor-pointer drop-shadow-md hover:scale-105 transition-transform"
          onClick={() => setPromoModalOpen(true)}
        />
      </div>

      {!promoModalOpen && (
        <button
          onClick={() => setPromoModalOpen(true)}
          style={{ backgroundColor: THEME.primary }}
          className="fixed right-0 top-1/2 p-2.5 transform -translate-y-1/2 text-white rounded-l-lg shadow-lg hover:opacity-95 transition-all z-40 flex items-center justify-center cursor-pointer"
        >
          <FaChevronLeft className="text-sm" />
        </button>
      )}

      {/* Promo / Notification Drawer Modal */}
      <Modal
        isOpen={promoModalOpen}
        onRequestClose={() => setPromoModalOpen(false)}
        contentLabel="Notifications"
        className="fixed right-0 top-1/2 transform -translate-y-1/2 w-72 bg-white shadow-2xl rounded-l-xl overflow-hidden border border-slate-200 z-50 outline-none"
        overlayClassName="fixed inset-0 bg-transparent z-40 pointer-events-none"
        style={{
          content: {
            pointerEvents: "auto",
          },
        }}
      >
        <div className="flex flex-col max-h-[85vh]">
          <div
            style={{ backgroundColor: THEME.primary }}
            className="p-3.5 text-white flex justify-between items-center"
          >
            <h2 className="text-xs font-bold tracking-wide uppercase">
              📢 Notifications {notificationData?.length ? `(${notificationData.length})` : ""}
            </h2>
            <button
              onClick={() => setPromoModalOpen(false)}
              className="text-white/80 hover:text-white w-6 h-6 rounded-full bg-white/10 flex items-center justify-center text-sm font-bold cursor-pointer"
            >
              ×
            </button>
          </div>

          {notificationData && notificationData.length > 0 ? (
            <div className="p-4 overflow-y-auto space-y-4 divide-y divide-slate-100">
              {notificationData.map((note, index) => (
                <div key={note.notification_id || index} className="pt-3 first:pt-0">
                  <h3 className="text-xs font-bold text-slate-800 mb-2 uppercase">
                    {note.title}
                  </h3>
                  {note.is_image === "1" && note.notification_image && (
                    <div className="mb-2 rounded-lg overflow-hidden border border-slate-200">
                      {(() => {
                        const baseUrl = SummaryApi.notifictionImg.url;
                        const imagePath = note.notification_image;
                        let fullImageUrl = `${baseUrl}/${imagePath}`.replace(
                          "images/images/",
                          "images/"
                        );
                        return (
                          <img
                            src={fullImageUrl}
                            alt={note.title}
                            className="w-full mx-auto"
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                          />
                        );
                      })()}
                    </div>
                  )}
                  <p className="text-xs text-slate-600 leading-relaxed line-clamp-3">
                    {note.description}
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <div className="p-5 text-center">
              <h3 className="text-xs font-semibold text-slate-500 mb-1">Introducing</h3>
              <h4 className="text-sm font-bold mb-3" style={{ color: THEME.primary }}>
                Sanjivani University
              </h4>
              <div className="text-xs text-slate-600 space-y-1.5 text-left bg-slate-50 p-3 rounded-lg border border-slate-100">
                <p>🏆 Quality Education</p>
                <p>📚 Career-Focused Programs</p>
                <p>🎯 Industry-Ready Skills</p>
              </div>
            </div>
          )}
        </div>
      </Modal>

      <FollowupModal
        isOpen={followUpModalIsOpen}
        onClose={() => {
          setFollowUpModalIsOpen(false);
          setFollowupModalStudent(null);
        }}
        student={followupModalStudent}
        onSuccess={() => {
          fetchTodayFollowups();
          setFollowUpModalIsOpen(false);
          setFollowupModalStudent(null);
        }}
      />
    </div>
  );
};

const DetailRow = ({ label, value, highlight = false }) => (
  <div className="flex items-start py-2.5 text-xs">
    <span className="w-36 font-medium text-slate-500 shrink-0">{label}</span>
    <span
      className={`flex-1 font-semibold break-words ${highlight ? "text-[#2563EB]" : "text-slate-800"
        }`}
    >
      {value || "N/A"}
    </span>
  </div>
);

export default Dashboard;